import { generate } from 'generate-password';

export const generatePassword = () => {
  const generatedPassword = generate({
    length: 10,
    numbers: true,
    strict: true
  });
  return generatedPassword;
}